export const GET_CP_REWARD = "GET_CP_REWARD";

export const OPEN_DIALOGUE_CP_REWARD = "OPEN_DIALOGUE_CP_REWARD";

export const CLOSE_DIALOGUE_CP_REWARD = "CLOSE_DIALOGUE_CP_REWARD";

export const CERATE_CP_REWARD = "CERATE_CP_REWARD";

export const UPDATE_CP_REWARD = "UPDATE_CP_REWARD";

export const DELETE_CP_REWARD = "DELETE_CP_REWARD";
